// Single source of truth for manager metadata.
// Adding a new manager: add one entry here. Nothing else needs to know.

export const MANAGERS = {
  'Anna':     {
    image: 'ai anna.jpeg', emoji: '👑', isFormer: false,
    currentTeamName: 'Phemale Phenom',
    tagline: 'The Phemale Phenom',
    description: 'Three-time champion. Back-to-back defending champ. Tied for the all-time ring lead.',
  },
  'Kyle':     {
    image: 'ai kyle.jpeg', emoji: '🏆', isFormer: false,
    currentTeamName: 'Quest for Ring #4',
    tagline: 'The Dynasty King',
    description: 'Three rings. The original dynasty. Samuel\'s nightmare.',
  },
  'Kevin':    {
    image: 'ai kevin.jpeg', emoji: '🎪', isFormer: false,
    currentTeamName: "Grundle's Grinders",
    tagline: '2023 Surprise Champion',
    description: 'From the basement to the crown in one year.',
  },
  'Samuel':   {
    image: 'ai sam.jpeg', emoji: '💀', isFormer: false,
    currentTeamName: 'The Maestro',
    tagline: 'Eternal Optimist',
    description: 'Eight seasons since joining in 2018. Zero rings. Still believes.',
  },
  'Bryan':    {
    image: 'AI Bryan.jpeg', emoji: '⚡', isFormer: false,
    currentTeamName: 'Better Managed',
    tagline: 'The Grinder',
    description: 'Twelve years of effort. Two regular-season crowns. Still grinding.',
  },
  'A.J.':     {
    image: 'AI AJ.jpeg', emoji: '🏛️', isFormer: false,
    currentTeamName: 'Highland Park Hitmen',
    tagline: 'The Gunslinger',
    description: 'Two-time champion — 2013 and 2021. High variance. Says this is the year.',
  },
  'Josh':     {
    image: 'ai josh.jpeg', emoji: '👶', isFormer: false,
    currentTeamName: 'Daddy',
    tagline: '"Daddy"',
    description: 'Hungry. Still hunting his first ring.',
  },
  'Amir':     {
    image: 'AI amir.jpeg', emoji: '🎭', isFormer: false,
    currentTeamName: 'Deportivo De La Amir',
    tagline: 'The Strategic Mind',
    description: '2019 champion. Operates on a different frequency.',
  },
  'Robby':    {
    image: 'ai robby.jpeg', emoji: '⚖️', isFormer: false,
    currentTeamName: 'Commissioner’s Army',
    tagline: 'The Commissioner',
    description: '2022 champion. Commissioner. Crusher of A.J.\'s dreams.',
  },
  'Ryan':     {
    image: 'ai ryan.jpeg', emoji: '🦏', isFormer: false,
    currentTeamName: "Rhino's Bunz",
    tagline: 'The Rhino',
    description: 'Regular-season warrior. Hardware-free.',
  },
  'Blake':    {
    image: null, emoji: '🏃', isFormer: true,
    tagline: 'Back-to-Back Champion',
    description: 'Five seasons, two rings: 2016 and 2017.',
  },
  'Michael R':{
    image: null, emoji: '🚪', isFormer: true,
    tagline: 'The Epic Exit',
    description: 'Two seasons. One legend. One exit story.',
  },
  'Alex':     {
    image: null, emoji: '🎬', isFormer: true,
    tagline: 'Team Hollywood',
    description: 'One season, 2013. Made the playoffs and left for the coast.',
  },
  'Harrison Williams': {
    image: null, emoji: '🚛', isFormer: true,
    tagline: 'The Juggernaut',
    description: 'One season, 2013. Went 10-4 with Peyton Manning and vanished.',
  },
};

export function getManagerImage(name) {
  return MANAGERS[name]?.image || null;
}

export function getManagerEmoji(name, fallback = '📊') {
  return MANAGERS[name]?.emoji || fallback;
}

export function isFormerMember(name) {
  return MANAGERS[name]?.isFormer === true;
}

export function getManagerTagline(name) {
  return MANAGERS[name]?.tagline || '';
}

export function getManagerDescription(name) {
  return MANAGERS[name]?.description || '';
}

export function getManagerTeamName(name) {
  return MANAGERS[name]?.currentTeamName || '';
}

export const FORMER_MEMBERS = Object.entries(MANAGERS)
  .filter(([, m]) => m.isFormer)
  .map(([name]) => name);

export const ACTIVE_MEMBERS = Object.entries(MANAGERS)
  .filter(([, m]) => !m.isFormer)
  .map(([name]) => name);

export const ALL_MEMBERS = Object.keys(MANAGERS);
